export const messages = {
  en: {
    miscFeeLedger: {
      all: 'All',
      query: 'Query',
      reset: 'Reset',
      exportFailed: 'Export failed',
      to: 'to',
      startTime: 'Start time',
      endTime: 'End time',
      feeType: 'Fee Type',
      flowType: 'Entry Type',
      payerObjName: 'Payer Object',
      ownerName: 'Owner',
      operatorName: 'Operator',
      createUserName: 'Billing Operator',
      payerObjPlaceholder: 'Enter room or parking space',
      ownerPlaceholder: 'Enter owner name',
      operatorPlaceholder: 'Enter operator',
      createUserPlaceholder: 'Enter billing operator',
      orderId: 'Document ID',
      orderIdPlaceholder: 'Entry, payment or refund ID',
      eventTime: 'Business Time',
      feeName: 'Fee Item',
      amount: 'Amount',
      payMethod: 'Payment Method',
      auditPersonName: 'Reviewer',
      sourceOrderId: 'Source ID',
      remark: 'Remark',
      income: 'Collection',
      refund: 'Refund',
      depositTransfer: 'Deposit Transfer',
      incomeAmount: 'Collected',
      refundAmount: 'Refunded',
      depositTransferAmount: 'Deposit Transferred',
      netAmount: 'Net Income',
      flowCount: 'Entries',
      incomeCount: 'Collections',
      refundCount: 'Refunds',
      depositTransferCount: 'Transfers',
      incomeRefundCount: '{income} collections, {refund} refunds',
      flowCountDetail: '{income} collections, {refund} refunds, {depositTransfer} transfers',
      detailLedger: 'Ledger Details',
      operatorStatistics: 'Operator Statistics',
      billingOperatorStatistics: 'Billing Operator Statistics',
      advertisementFee: 'Advertising Fee',
      decorationDeposit: 'Decoration Deposit',
      temporaryServiceFee: 'Temporary Service Fee',
      venueMiscellaneousFee: 'Venue Miscellaneous Fee'
    }
  },
  zh: {
    miscFeeLedger: {
      all: '全部',
      query: '查询',
      reset: '重置',
      exportFailed: '导出失败',
      to: '至',
      startTime: '开始时间',
      endTime: '结束时间',
      feeType: '费用类型',
      flowType: '流水类型',
      payerObjName: '付费对象',
      ownerName: '业主',
      operatorName: '操作员',
      createUserName: '开单人',
      payerObjPlaceholder: '请输入房屋或车位',
      ownerPlaceholder: '请输入业主姓名',
      operatorPlaceholder: '请输入操作员',
      createUserPlaceholder: '请输入开单人',
      orderId: '单据编号',
      orderIdPlaceholder: '流水、原缴费或退款单号',
      eventTime: '业务时间',
      feeName: '费用项',
      amount: '金额',
      payMethod: '支付方式',
      auditPersonName: '审核人',
      sourceOrderId: '来源单号',
      remark: '备注',
      income: '收款',
      refund: '退款',
      depositTransfer: '押金转存',
      incomeAmount: '收款金额',
      refundAmount: '退款金额',
      depositTransferAmount: '押金转存金额',
      netAmount: '净收入',
      flowCount: '流水笔数',
      incomeCount: '收款笔数',
      refundCount: '退款笔数',
      depositTransferCount: '转存笔数',
      incomeRefundCount: '收款 {income} 笔，退款 {refund} 笔',
      flowCountDetail: '收款 {income} 笔，退款 {refund} 笔，押金转存 {depositTransfer} 笔',
      detailLedger: '流水明细',
      operatorStatistics: '操作员统计',
      billingOperatorStatistics: '开单人统计',
      advertisementFee: '广告费',
      decorationDeposit: '装修押金',
      temporaryServiceFee: '临时服务费',
      venueMiscellaneousFee: '场地杂费'
    }
  },
  'zh-TW': {
    miscFeeLedger: {
      all: '全部',
      query: '查詢',
      reset: '重置',
      exportFailed: '導出失敗',
      to: '至',
      startTime: '開始時間',
      endTime: '結束時間',
      feeType: '費用類型',
      flowType: '流水類型',
      payerObjName: '付費對象',
      ownerName: '業主',
      operatorName: '操作員',
      createUserName: '開單人',
      payerObjPlaceholder: '請輸入房屋或車位',
      ownerPlaceholder: '請輸入業主姓名',
      operatorPlaceholder: '請輸入操作員',
      createUserPlaceholder: '請輸入開單人',
      orderId: '單據編號',
      orderIdPlaceholder: '流水、原繳費或退款單號',
      eventTime: '業務時間',
      feeName: '費用項',
      amount: '金額',
      payMethod: '支付方式',
      auditPersonName: '審核人',
      sourceOrderId: '來源單號',
      remark: '備註',
      income: '收款',
      refund: '退款',
      depositTransfer: '押金轉存',
      incomeAmount: '收款金額',
      refundAmount: '退款金額',
      depositTransferAmount: '押金轉存金額',
      netAmount: '淨收入',
      flowCount: '流水筆數',
      incomeCount: '收款筆數',
      refundCount: '退款筆數',
      depositTransferCount: '轉存筆數',
      incomeRefundCount: '收款 {income} 筆，退款 {refund} 筆',
      flowCountDetail: '收款 {income} 筆，退款 {refund} 筆，押金轉存 {depositTransfer} 筆',
      detailLedger: '流水明細',
      operatorStatistics: '操作員統計',
      billingOperatorStatistics: '開單人統計',
      advertisementFee: '廣告費',
      decorationDeposit: '裝修押金',
      temporaryServiceFee: '臨時服務費',
      venueMiscellaneousFee: '場地雜費'
    }
  }
}
